import { SearchableDropdownSelect } from './searchable-dropdown-select';

const webComponents = [
  {
    name: 'searchable-dropdown-select',
    component: SearchableDropdownSelect,
  },
];

export const registerWebComponents = () => {
  webComponents.forEach((component) => {
    customElements.define(component.name, component.component);
  });
};
